import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { JsonDataService } from '../../../shared/services/json-data.service';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-work-at-luminous',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './work-at-luminous.component.html',
  styleUrl: './work-at-luminous.component.scss'
})
export class WorkAtLuminousComponent implements OnInit, OnDestroy {
  environment: any = environment;
  tabName: any;
  sub:Subscription=new Subscription()
  careerMetaData: any;
  aboutMetaData: any;
  constructor(public route: ActivatedRoute, private router: Router, public utils: UtilsService, private metaSvc: MetaMgmtService,private jsonDataService: JsonDataService) {
    this.getJsonData();
  }

  ngOnInit(): void {
    this.utils.showHeaderFooter.next(true);
    this.getJsonData();
  }
 
  getJsonData() {
    this.sub.add(this.jsonDataService.getworkatluminousJsonData().subscribe({
      next: (res: any) => {
        this.utils.hideLoading();
        this.aboutMetaData = res.aboutMetaData;
        this.careerMetaData=res.careerMetaData
        this.init();
      },
      error: (err: any) => {
        this.utils.hideLoading();
      }
    }));
    this.utils.showHeaderFooter.next(true);

  }
  init() {
    let page = this.utils.getActiveRouter(this.router.url);
    this.sub.add(  this.route.params.subscribe((params: any) => {
      this.tabName = params['tabName'] ? params['tabName'].toLowerCase() : '';
      if (page == 'about-us') {
        let data = this.aboutMetaData.filter((x: any) => { if (x.name === this.tabName) return x })
          let metaData: any = {
            canonicalURL: data[0]?.canonicalUrl,
          description: data[0]?.description,
          pageTitle: data[0]?.title,
          keywords: data[0]?.keywords
        }
        this.metaSvc.updateMetaTags(metaData);
      }
      else {
        let data = this.careerMetaData.filter((x: any) => { if (x.name === this.tabName) return x })
        let metaData: any = {
          canonicalURL: data[0].canonicalUrl,
          description: data[0].description,
          pageTitle: data[0].title,
          keywords: data[0].keywords
        }
        this.metaSvc.updateMetaTags(metaData);
      }
      if ((this.tabName != 'customer-first' && this.tabName != 'dare-to-disrupt' && this.tabName != 'embrace-different' && this.tabName != 'learn-everyday' && this.tabName != 'act-like-owners') || !this.tabName) {
        this.router.navigate(['career']);
      }
    }));
  }
 
  ngOnDestroy(): void {
    this.sub.unsubscribe()
  }

}
